import { render, staticRenderFns } from "./DialogRoom.vue?vue&type=template&id=c2f7390c&scoped=true"
import script from "./DialogRoom.vue?vue&type=script&lang=js"
export * from "./DialogRoom.vue?vue&type=script&lang=js"
import style0 from "./DialogRoom.vue?vue&type=style&index=0&id=c2f7390c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f7390c",
  null
  
)

export default component.exports